// @ts-nocheck
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import {
    chain,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchRefundEvent } from "@store/Services/AnalyticsService";
import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type SendRmaRequestParameter = {
    orderNumber: string;
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<RmaModel>;
type HandlerType = ApiHandlerDiscreteParameter<SendRmaRequestParameter, AddRmaApiParameter, ServiceResult<RmaModel>>;

const PopulateApiParameterExpands: HandlerType = props => {
    const state = props.getState();
    props.apiParameter.rmaModel.properties = {
        email: state.store.pages.requestRma.email || "",
        phoneNumber: state.store.pages.requestRma.phoneNumber || "",
    };
};

const StoreExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
        dispatchRefundEvent(props.apiParameter.rmaModel); // Store Custom Code
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterExpands);
replaceInChain(chain, ExecuteOnSuccessCallback, StoreExecuteOnSuccessCallback);
